module.exports = __webpack_public_path__ + "static/media/deposit.2e8c95ce.png";